import { createContext, useContext } from "react";

export interface MaintenanceContextType {
  isMaintenanceMode: boolean;
  maintenanceMessage: string | null;
  isLoading: boolean;
}

export const MaintenanceContext = createContext<MaintenanceContextType | undefined>(undefined);

export const useMaintenance = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error("useMaintenance must be used within a MaintenanceProvider");
  }
  return context;
};
